import { BRAND, isMarketGB } from 'src/constants/main';
import { CantFindYourDreamCarStyled } from './CantFindYourDreamCarStyled';
import { SC } from 'src/styles/theme';
import React from 'react';
import { CantFindYourDreamCarStyledAC } from './AC/CantFindYourDreamCarStyledAC';
import { CantFindYourDreamCarStyledAP } from './AP/CantFindYourDreamCarStyledAP';
import { CantFindYourDreamCarStyledDS } from './DS/CantFindYourDreamCarStyledDS';
import { CantFindYourDreamCarStyledOV } from './OV/CantFindYourDreamCarStyledOV';
import { CantFindYourDreamCarStyledOVGB } from './OV/CantFindYourDreamCarStyledOVGB';

export interface CantFindYourDreamCarProps extends SC {}

export const CantFindYourDreamCar = (props: CantFindYourDreamCarProps) => {
    if (BRAND === 'AC') return <CantFindYourDreamCarStyledAC {...props} />;
    if (BRAND === 'AP') return <CantFindYourDreamCarStyledAP {...props} />;
    if (BRAND === 'DS') return <CantFindYourDreamCarStyledDS {...props} />;
    if (BRAND === 'OV')
        return isMarketGB ? <CantFindYourDreamCarStyledOVGB {...props} /> : <CantFindYourDreamCarStyledOV {...props} />;
    return <CantFindYourDreamCarStyled {...props} />;
};

export default CantFindYourDreamCar;
